import {stage} from "./stage.ts";

type ConfigShape = {
    [key in 'prd' | 'test' | 'dev' | 'ide']: {
        baseUrl: string,
    }
}

// An empty base URL means the handoff page is not available on that stage.
const config: ConfigShape = {
    prd: {
        baseUrl: '',
    },
    test: {
        baseUrl: '',
    },
    dev: {
        baseUrl: 'https://oidc.api.platform-dev.nextcloud.aero',
    },
    ide: {
        baseUrl: 'https://oidc.api.platform-dev.nextcloud.aero',
    },
};

export const broker = config[stage];
